import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const VirtualTourCard = ({ tour, onStart }) => {
  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic group">
      <div className="relative h-56 overflow-hidden">
        <Image
          src={tour?.thumbnail}
          alt={tour?.thumbnailAlt}
          className="w-full h-full object-cover group-hover:scale-105 animation-organic"
        />
        <div className="absolute inset-0 gradient-conservation opacity-50 group-hover:opacity-30 animation-organic"></div>
        
        {/* 360 Badge */}
        <div className="absolute top-4 left-4 bg-primary px-3 py-1 rounded-full flex items-center gap-1">
          <Icon name="Maximize2" size={14} color="var(--color-primary-foreground)" />
          <span className="text-xs font-medium text-primary-foreground">360° Tour</span>
        </div>

        {/* Duration */}
        <div className="absolute top-4 right-4 bg-black/70 px-3 py-1 rounded-full flex items-center gap-1">
          <Icon name="Clock" size={14} color="white" />
          <span className="text-xs font-medium text-white">{tour?.duration}</span>
        </div>

        {/* Play Button Overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 animation-organic">
          <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center shadow-conservation-lg">
            <Icon name="Play" size={28} color="var(--color-primary-foreground)" />
          </div>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold text-foreground mb-2">{tour?.title}</h3>
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">{tour?.description}</p>

        {/* Tour Stats */}
        <div className="flex items-center gap-4 mb-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="MapPin" size={14} />
            <span>{tour?.locations} Locations</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Eye" size={14} />
            <span>{tour?.views} Views</span>
          </div>
        </div>

        {/* Highlights */}
        <div className="flex flex-wrap gap-2 mb-4">
          {tour?.highlights?.slice(0, 2)?.map((highlight, index) => (
            <span
              key={index}
              className="text-xs bg-muted px-2 py-1 rounded text-muted-foreground"
            >
              {highlight}
            </span>
          ))}
        </div>

        <Button
          variant="default"
          size="sm"
          iconName="Play"
          iconPosition="left"
          onClick={() => onStart(tour)}
          fullWidth
        >
          Start Virtual Tour
        </Button>
      </div>
    </div>
  );
};

export default VirtualTourCard;